import React from "react";
import { FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModalTemplate } from "themes/application/facility-order-new-flow/components";
import { FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModalStore } from 'application/facility-order-new-flow/stores';
import { observer } from "mobx-react";
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModalStore(rootStore, componentProps), 'facilityOrderTemplateNewFlowCustomOrderingDoctorChangeModalStore')
@observer
class FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModal extends React.Component {
	render() {
		return <FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModalTemplate {...this.props} />;
	}
}

export default FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModal;